import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

/* ============================================================
   🔹 SUBIDA DE IMÁGENES
   ============================================================ */
export async function uploadImageAppCliente(file) {
  const token = getAuthToken();
  const formData = new FormData();

  // El backend espera el campo "imagen"
  formData.append("imagen", file);

  const response = await fetch(`${CALL_API}/uploadappclientes`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al subir la imagen");

  // Respuesta esperada: { filename, url }
  return {
    filename: data.filename,
    url: data.url,
  };
}

/* ============================================================
   📰 NOVEDADES
   ============================================================ */
export async function getAllNovedades() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallnovedades`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al obtener novedades");
  return data.result;
}

export async function insertNovedad(objeto) {
  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/insertnovedad`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al insertar novedad");

  return data.isSaved;
}

export async function updateNovedad(objeto) {
  const { idnovedad } = objeto;
  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/updatenovedad/${idnovedad}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al actualizar novedad");

  return data.isSaved;
}

export async function deleteNovedad(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deletenovedad/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al eliminar novedad");
  return data.isDeleted;
}

/* ============================================================
   📱 SERVICIOS
   ============================================================ */
export async function getAllServicios() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallservicios`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al obtener servicios");

  return data.result;
}

export async function insertServicio(objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertservicio`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al insertar servicio");

  return data.isSaved;
}

export async function updateServicio(objeto) {
  const { idservicio } = objeto;
  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/updateservicio/${idservicio}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al actualizar servicio");

  return data.isSaved;
}

export async function deleteServicio(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deleteservicio/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al eliminar servicio");
  return data.isDeleted;
}
